<template>
  <v-card>
    <v-card-title>
      <h3 class="toolbar__title">Payment Method Status</h3>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :options="pagination"
      mobile-breakpoint="0"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.active ? 'Yes' : 'No'}}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import paginationMixin from '@/mixins/pagination'

  export default {
    props: {
      items: Array
    },

    mixins: [
      paginationMixin
    ],

    data () {
      return {
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Active',
            align: 'left',
            sortable: false,
            value: 'active'
          }
        ],

        pagination: {
          rowsPerPage: -1
        }
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/PaymentConfig.vue